export default Object.freeze({ DMM: 'dmm', FACEBOOK: 'facebook', GOOGLE: 'google' });
